<div class="wrapper" routerLink="/wallet/deposits">
  <div class="icon">
    <icon name="ph:cardholder-fill" color="primary-color" size="26" />
  </div>
  <div class="label">
    <p>{{ 'WALLET.Deposit' | translate }}</p>
  </div>
</div>
